import SocketClient from "@/socket";
const state = {
    modal_confirm_send_message: false,
    modal_ng_word_message: false,
    modal_reload: false,
    current_user: {}, // {id }
    current_kara: {}, // {id , token}

    user_chat_list: [],
    user_chat_list_total_page: 1,
    user_chat_list_current_page: 1,

    message_chat_list: [], // { 'time': , 'u_id': , 'r_id': , 'msg': , type: 'message' }
    kara_last_send_message: null,
    user_last_read_message: null,
    message_input: '',
    ngword_message: '',
    online_status: false,
    socket_client: null,
    isTargetTypping: false,
    isSending: false,
}

const mutations = {
    SET_CURRENT_KARA(state, info) {
        state.current_kara = info;
    },

    SET_CURRENT_USER(state, user) {
        state.current_user = user;
    },

    SET_SOCKET_CLIENT(state, socket) {
        state.socket_client = socket;
    },

    SET_USER_CHAT_LIST(state, user_list) {
        state.user_chat_list = user_list;
    },

    SET_USER_CHAT_LIST_PAGE(state, { total_page, current_page }) {
        state.user_chat_list_total_page = total_page;
        state.user_chat_list_current_page = current_page;
    },

    UPDATE_ONLINE_STATUS(state, status) {
        state.online_status = status;
    },

    // UPDATE_NEW_MESSAGE(state, message) {
    //     // chat timmer
    //     // if (message.timer_id) {
    //     //     state.message_chat_list.map((current_show_message, index) => {
    //     //         // remove chattimer for real message.
    //     //         if (current_show_message.chat_timer && message.timer_id == current_show_message.chat_timer) {
    //     //             state.message_chat_list.splice(index, 1);    
    //     //         }
    //     //     });
    //     // }
    //     // show new message to front end
    //     console.log('[updateNewMessage] add new message', message.time);
    //     store.state.message.messages.push(message);
    // },

    UPDATE_HISTORY_MESSAGE(state, message_list) {
        if (Array.isArray(message_list)) {
            state.message_chat_list = message_list;
        } else {
            //neu message_list khong phai array -> load default empty array
            console.warn('[updateHistoryMessage] message_list not array, use default []!');
            state.message_chat_list = [];
        }
    },

    UPDATE_TARGET_TYPING(state, typing) {
        state.isTargetTypping = typing;
    },

    // UPDATE_MESSAGE_INPUT(state, input_message) {
    //     if (input_message == '') {
    //         state.socket_client.typingMessage(state.current_user.id, 0);
    //     } else {
    //         if (input_message.length == 1) {
    //             let mode = parent.scheduleType.val();
    //             // dat note: trong che do timer, typing khong duoc hien tren app (mode != 0)
    //             if (mode == 0) {
    //                 state.socket_client.typingMessage(state.current_user.id, 1);
    //             }
    //         }
    //     }

    //     state.message_input = input_message;
    // },

    UPDATE_MODAL_CONFIRM_MESSAGE(state, status) {
        state.modal_confirm_send_message = status;
    },

    UPDATE_MODAL_NG_WORD_MESSAGE(state, status) {
        state.modal_ng_word_message = status;
    },

    UPDATE_MODAL_RELOAD(state, status) {
        state.modal_reload = status;
    },

    UPDATE_SENDING_STATUS(state, status) {
        if (status) {
            // console.log('[updateSendingStatus] sendding....');
        } else {
            // console.log('[updateSendingStatus] sent');
        }
        state.isSending = status;
    },

    UPDATE_KARA_LAST_SEND_MESSAGE(state, message) {
        state.kara_last_send_message = message;
    },

    UPDATE_USER_LAST_READ_MESSAGE(state, message) {
        state.user_last_read_message = message;
    },

    UPDATE_MESSAGE_IS_READ(state, index) {
        state.message_chat_list[index].received = 0;
    },

    UPDATE_IMAGE_IS_OPEN(state, index) {
        state.message_chat_list[index].showed = 1;
    }
}
const actions = {
    initState(context) {
        let socket_client = new SocketClient(this);
        socket_client.initSocket(process.env.VUE_APP_SOCKET, context);
        context.commit('SET_SOCKET_CLIENT', socket_client);
    },
    receiveMessage(context, params) {
        state.socket_client.receiveMessage(params.time, params.user_id)
    },
    typingMessage(context, params) {
        state.socket_client.typingMessage(params.user_id)
    },
    setupSocketChattingEvent(context) {
        state.socket_client._setupSocketChattingEvent

    },
    setCurrentUser({ commit }, params) {
        commit('SET_CURRENT_USER', params.user)
    },
    openImage(context, params) {
        state.socket_client.openImage(params.message)
    },
    // updateMessage({commit}, params) {
    //     commit('UPDATE_NEW_MESSAGE', params.message)
    // },
    // // clear message unread for current user
    // clearMessageUnread(context, user_id) {
    //     // tim trong roster list neu co user_id thi set message unread ve 0
    //     for (let index = 0; index < context.state.user_chat_list.length; index++) {
    //         if (context.state.user_chat_list[index].id == user_id) {
    //             context.state.user_chat_list[index].unread = 0;
    //         }
    //     }
    // },

    // updateMessageUnread(context, user_id) {
    //     // tim trong roster list neu co user_id thi set message unread +1
    //     for (let index = 0; index < context.state.user_chat_list.length; index++) {
    //         if (context.state.user_chat_list[index].id == user_id) {
    //             context.state.user_chat_list[index].unread += 1;
    //         }
    //     }
    // },

    // // chuyen sang chat voi user khac
    // addUser(context, { user, change_user }) {
    //     if (user.id && user.id != context.state.current_user.id) {
    //         // neu khong tim thay trong roster list thi them vao roster list
    //         if (context.state.user_chat_list.findIndex(x => x.id == user.id) == -1) {
    //             context.state.user_chat_list.unshift(user);
    //         }

    //         if (change_user) {
    //             // change current user
    //             context.state.message_chat_list = [];
    //             context.commit('SET_CURRENT_USER', user);
    //             context.dispatch('getCurrentHistoryMessage');

    //             // call show user info
    //             parent.showUserInfo('', user.id).then(info => {
    //                 let user_index = context.state.user_chat_list.findIndex(x => x.id == info.id);
    //                 if (user_index !== -1) {
    //                     context.state.user_chat_list[user_index] = info;
    //                     Vue.set(context.state.user_chat_list, user_index, info);
    //                 }
    //             });
    //         } else {
    //             // get user info
    //             parent.getUserInfo('', user.id).then(info => {
    //                 let user_index = context.state.user_chat_list.findIndex(x => x.id == info.id);
    //                 if (user_index !== -1) {
    //                     context.state.user_chat_list[user_index] = info;
    //                     Vue.set(context.state.user_chat_list, user_index, info);
    //                 }
    //             });
    //         }
    //     }
    // },

    // removeUser(context, user) {
    //     // check user is exist in roster
    //     let user_index = context.state.user_chat_list.findIndex(x => x.id == user.id);
    //     if (user_index !== -1) {
    //         // check if remove user has unread -> show alert
    //         if (user.unread) {
    //             if (!confirm(LANG.do_you_want_close_chat_with_unread)) {
    //                 return false;
    //             }
    //         }

    //         // call remove user
    //         let params = { kara_id: context.state.current_kara.id, user_id: user.id };
    //         console.log('---------param:', params);
    //         context.state.user_chat_list.splice(user_index, 1);
    //         console.log('-----user_chat_list', context.state.user_chat_list);
    //         _removeUser(BASE_PATH, params);

    //         // check remove user is active
    //         if (user.id == context.state.current_user.id) {
    //             // check if user_chat_list has another user
    //             if (context.state.user_chat_list.length > 0) {
    //                 // if has user -> set current user  = first user
    //                 console.log('--------user_chat_list[0]:', context.state.user_chat_list[0]);
    //                 context.commit('SET_CURRENT_USER', context.state.user_chat_list[0]);
    //                 context.dispatch('getCurrentHistoryMessage');
    //             } else {
    //                 // if user_chat_list is null array -> set current user = null object
    //                 console.log('-------SET_CURRENT_USER null');
    //                 context.commit('SET_CURRENT_USER', {});
    //             }
    //         }
    //     }
    // },

    // getRosterForCurrentKara(context, page) {
    //     // clear message list first
    //     context.commit('UPDATE_HISTORY_MESSAGE', []);

    //     if (page != state.user_chat_list_current_page || page == '') {
    //         // load roster for current kara
    //         // parent.toggleIframeLoading(true);

    //         let params = {
    //             p: page,
    //             l: 10,
    //             id: context.state.current_user.id
    //         }
    //         _getHistoryUserList(BASE_PATH, params).then((data) => {
    //             let result = data.result;
    //             if (result && Array.isArray(result)) {
    //                 context.commit('SET_USER_CHAT_LIST', result);

    //                 // set current chat user = first user in result user list
    //                 if (result.length != 0) {
    //                     context.commit('SET_USER_CHAT_LIST_PAGE', { total_page: Math.ceil(data.total / 10), current_page: data.p });
    //                     context.commit('SET_CURRENT_USER', { id: result[0].id, user_code: result[0].user_code });
    //                     parent.showUserInfo(result[0].user_code);
    //                     context.dispatch('getCurrentHistoryMessage');
    //                 } else {
    //                     console.log('[VUEX - initState] no roster', result);
    //                 }
    //             } else {
    //                 console.warn('[VUEX - initState] get roster false: ', result);
    //             }
    //         });
    //     }
    // },

    // getCurrentHistoryMessage(context) {
    //     // load history message for current user
    //     parent.toggleIframeLoading(true);

    //     let params2 = {
    //         limit: 20,
    //         seq: '',
    //         from: context.state.current_kara.id,
    //         to: context.state.current_user.id
    //     }
    //     _getHistoryMessage(BASE_PATH, params2).then((result2) => {
    //         if (result2 && Array.isArray(result2) && result2.length > 0) {

    //             // check message list co phai cua user chat hien tai hay khong
    //             if (result2[0].u_id == context.state.current_user.id || result2[0].r_id == context.state.current_user.id) {
    //                 // luu lai last message cua user (r_id == current user chat id) (dung de danh dau read-unread)
    //                 let last_message = context.state.last_message;
    //                 result2.map((message, index) => {
    //                     // for last message
    //                     if (message.u_id == context.state.current_user.id && !last_message) {
    //                         last_message = message;
    //                     }

    //                     // // for message timer
    //                     // if (message.chat_timer && message.msg_timer) {
    //                     //     if (!message.msg_timer.type || message.msg_timer.type == 'text') {
    //                     //         result2[index].type = "text";
    //                     //         result2[index].received = 2; // chua doc
    //                     //         result2[index].msg = message.msg_timer.msg;
    //                     //         result2[index].msgid = randomString(20);
    //                     //         result2[index].time = message.msg_timer.timestamp;
    //                     //     }
    //                     // }
    //                 });

    //                 if (last_message) {
    //                     context.commit('UPDATE_KARA_LAST_SEND_MESSAGE', last_message);
    //                 }
    //                 // luu lai last message cua user end

    //                 // cap nhat message list
    //                 if (context.state.message_chat_list && context.state.message_chat_list != []) {
    //                     context.commit('UPDATE_HISTORY_MESSAGE', context.state.message_chat_list.concat(result2));
    //                 } else {
    //                     context.commit('UPDATE_HISTORY_MESSAGE', result2);
    //                 }
    //             }
    //         } else {
    //             console.warn('[VUEX - initState] message history false: ', result2);
    //         }

    //         parent.toggleIframeLoading(false);
    //     });
    // },

    // updateUserOnline(context, user_status) {
    //     for (let index = 0; index < context.state.user_chat_list.length; index++) {
    //         if (context.state.user_chat_list[index].id == user_status.uid) {
    //             context.state.user_chat_list[index].is_online = user_status.online;
    //         }
    //     }
    // },

    // updateUserPoint(context, user_point) {
    //     console.log('point:::::', user_point);
    //     for (let index = 0; index < context.state.user_chat_list.length; index++) {
    //         // console.log(user_point.uid);

    //         if (context.state.user_chat_list[index].id == user_point.uid) {
    //             context.state.user_chat_list[index].point = user_point.point;
    //         }
    //     }
    // },

    // updateMessageIsRead(context, is_read_message) {
    //     for (let index = 0; index < context.state.message_chat_list.length; index++) {
    //         let kara_message = context.state.message_chat_list[index];
    //         // message of kara has time < is_read message
    //         if (kara_message.u_id == is_read_message.u_id && kara_message.time <= is_read_message.time) {
    //             if (kara_message.received > 0) {
    //                 if (!kara_message.chat_timer) {
    //                     //neu message chua doc -> set da doc
    //                     console.log('message is read::', kara_message);
    //                     context.commit('UPDATE_MESSAGE_IS_READ', index);
    //                 }
    //             } else {
    //                 //neu message da doc -> ket thuc lap
    //                 break;
    //             }
    //         }
    //     }
    // },

    // actionTargetOpenImage(context, open_message) {
    //     for (let index = 0; index < context.state.message_chat_list.length; index++) {
    //         let kara_message = context.state.message_chat_list[index];
    //         let msg_id = kara_message.u_id + '-' + kara_message.r_id + '-' + kara_message.time;

    //         // message of kara has id == open_image_message
    //         if (msg_id == open_message.msg_id) {
    //             console.log('Image is open::', kara_message);
    //             context.commit('UPDATE_IMAGE_IS_OPEN', index);
    //             break;
    //         }
    //     }
    // },

    // sendMessageTimer(context, message_timer) {
    //     context.state.socket_client.typingMessage(context.state.current_user.id, 0);

    //     message_timer.user_target_id = context.state.current_user.id;
    //     message_timer.kara_id = context.state.current_kara.id;
    //     message_timer.message = context.state.message_input;
    //     message_timer.tags = context.state.current_user.user_code + '(' + context.state.current_user.user_code + ')';
    //     message_timer.sakura_id = SAKURA_INFO.id;

    //     // add de phan biet voi kara-history-user chat timer
    //     message_timer.sakura_chat = 1;

    //     _postMessageTimer(BASE_PATH, message_timer).then(result => {
    //         if (result) {
    //             console.log('send message timer::::', result);

    //             // result tra ve la timer, khong phai message nen phai tach ra nhieu message timer de hien thi
    //             let timestamp = result.timestamp * 1000;
    //             let u_id = message_timer.kara_id;
    //             let r_id = message_timer.user_target_id;
    //             let sakura_id = message_timer.sakura_id;
    //             let stop_when_received = message_timer.stop_when_received;

    //             // for text message
    //             if (result.message) {
    //                 let text_message = {
    //                     msg_id: u_id + '_' + r_id + '_' + timestamp,
    //                     u_id: u_id,
    //                     r_id: r_id,
    //                     type: 'text',
    //                     msg: message_timer.message,
    //                     time: timestamp,
    //                     chat_timer: result.id,
    //                     received: 2,
    //                     showed: 0,
    //                     stop_when_received: stop_when_received, 
    //                     sakura_id: sakura_id
    //                 };

    //                 context.commit('UPDATE_NEW_MESSAGE', text_message);
    //             }

    //             // for image message
    //             if (Array.isArray(result.media) && result.media.length > 0) {
    //                 let image_timestamp = timestamp + 1;

    //                 let image_message = {
    //                     msg_id: u_id + '_' + r_id + '_' + image_timestamp,
    //                     u_id: u_id,
    //                     r_id: r_id,
    //                     type: 'image',
    //                     msg: '',
    //                     time: image_timestamp,
    //                     chat_timer: result.id,
    //                     received: 2,
    //                     showed: 0,
    //                     stop_when_received: stop_when_received, 
    //                     sakura_id: sakura_id,
    //                     param: result.media
    //                 };

    //                 context.commit('UPDATE_NEW_MESSAGE', image_message);
    //             }

    //             // for location message
    //             if (result.location) {
    //                 let location_timestamp = timestamp + 2;

    //                 let location_message = {
    //                     msg_id: u_id + '_' + r_id + '_' + location_timestamp,
    //                     u_id: u_id,
    //                     r_id: r_id,
    //                     type: 'location',
    //                     msg: '',
    //                     time: location_timestamp,
    //                     chat_timer: result.id,
    //                     received: 2,
    //                     showed: 0,
    //                     stop_when_received: stop_when_received, 
    //                     sakura_id: sakura_id,
    //                     param: JSON.parse(result.location)
    //                 };

    //                 context.commit('UPDATE_NEW_MESSAGE', location_message);
    //             }

    //             context.state.socket_client.clearUnread();
    //             context.dispatch('clearMessageUnread', message_timer.user_target_id);
    //             context.commit('UPDATE_SENDING_STATUS', false);
    //             context.commit('UPDATE_MESSAGE_INPUT', '');
    //         }
    //     })

    //     parent.clearChatTimerForm();
    // },

    // deleteMessageTimer(context, message) {
    //     if (message.chat_timer) {
    //         context.commit('UPDATE_SENDING_STATUS', true);

    //         _deleteMessageTimer(BASE_PATH, { 'id': message.chat_timer, 'user_id': message.r_id }).then(result => {
    //             if (result && result.timer_id) {
    //                 console.log('delete timer:::', result);

    //                 // remove chattimer for real message.
    //                 let msg_chat_list = context.state.message_chat_list.filter(current_show_message => {
    //                     return (!current_show_message.chat_timer || result.timer_id != current_show_message.chat_timer);
    //                 });

    //                 context.commit('UPDATE_HISTORY_MESSAGE', msg_chat_list);
    //             }

    //             context.commit('UPDATE_SENDING_STATUS', false);
    //         });
    //     } else {
    //         console.warn('[VUE] cannot delete non timer message');
    //     }
    // },

    sendMessage(context, params) {
        state.socket_client.sendMessage(params.message, params.user_id)
    },
    sendGift(context, params) {
        state.socket_client.sendGift(params.gift_id, params.user_id)
    },

    sendImage(context, params) {
        if (params.file.media_id && params.user_id) {
            let send_file = {
                type: 1,
                file_id: params.file.media_id,
                file_name: params.file.name_original,
                ext: params.file.name_original.split('.').pop(),
                size: params.file.size,
                height: params.file.height,
                width: params.file.width,
                mime: params.file.mime
            }

            context.state.socket_client.sendImage(send_file, params.user_id);
        } else {
            console.log('[VUEX - sendImage] current user or file not found');
        }
    },

    sendLocation(context, params) {
        if (params.location.lat && params.location.long && params.user_id) {
            let result = state.socket_client.sendLocation(params.location, params.user_id)
        } else {
            console.log('[VUEX - sendLocation] current user or location not found');
        }
    },

    // uploadChatImage(context, file) {
    //     return _postUploadImage(BASE_PATH, { id: context.state.current_kara.id, file: file }).then(file_detail => {
    //         context.dispatch('sendImage', file_detail);
    //         return true;
    //     });
    // }

    clientChatCall(context, params) {
        state.socket_client.clientChatCall(params);
    },

    clientCallProcess(context, params) {
        state.socket_client.clientCallProcess(params);
    },

    sendAnswerToRemote(context, params) {
        return state.socket_client.sendAnswerToRemote('hello', 1156, params);
    },

    setupSocketCallEvent() {
        state.socket_client.setupSocketCallEvent();
    },

    sendCandidate(context, params) {
        state.socket_client.sendCandidate(params);
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}